/**
 * assign-lib.ts — Hàm thuần cho hộp "Giao lại" và thanh người phụ trách.
 */
import type { AssignCandidate } from '@/hooks/use-conversations'
import { i18n } from '@/lib/i18n'

const fold = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase()

/** Lọc theo tên không dấu; giữ thứ tự máy chủ đã sắp (trực tuyến trước, ít việc trước). */
export function filterCandidates(list: AssignCandidate[], q: string): AssignCandidate[] {
  const f = fold(q.trim())
  return f ? list.filter((m) => fold(m.fullName).includes(f)) : list
}

/** Nhãn nhỏ cạnh tên: quản trị / quản lý kênh; Tiếp nhận là mức thường nên không gắn nhãn. */
export function levelBadge(level: AssignCandidate['level']): string | null {
  if (level === 'all') return i18n.t('convList:assign.levelAll')
  if (level === 'manage') return i18n.t('convList:assign.levelManage')
  return null
}

export type AssignBarState =
  | { kind: 'unassigned'; canClaim: boolean; canAssign: boolean }
  | { kind: 'mine'; canAssign: boolean }
  | { kind: 'other'; name: string; canAssign: boolean }

/** Trạng thái thanh phụ trách ở đầu khung chat — null khi chưa tải xong chi tiết hội thoại. */
export function assignBarState(
  conv: { assignedUserId?: string | null; assignee?: { fullName: string } | null; assignAccess?: { claim: boolean; assign: boolean } } | undefined,
  myId: string | undefined,
): AssignBarState | null {
  if (!conv || !conv.assignAccess) return null
  if (!conv.assignedUserId) return { kind: 'unassigned', canClaim: conv.assignAccess.claim, canAssign: conv.assignAccess.assign }
  if (conv.assignedUserId === myId) return { kind: 'mine', canAssign: conv.assignAccess.assign }
  return { kind: 'other', name: conv.assignee?.fullName ?? i18n.t('convList:assign.otherStaff'), canAssign: conv.assignAccess.assign }
}
